export default {
  title: 'צפייה בעמלות סוכנות',
  action: 'היסטוריית הסכמים',
  noHistoryData: 'אין נתונים להצגה',
  details: {
    company: 'חברה מנהלת',
    product: 'מוצר',
    agencyFeeMonthlyDeposit: 'עמלת סוכנות נפרעים מהפקדה %',
    agencyFeeMonthlyAccumulation: 'עמלת סוכנות נפרעים מצבירה %',
    agencyFeeAnnualAccumulation: 'עמלת סוכנות היקף מצבירה %',
    agencyFeeAnnualDeposit: 'עמלת סוכנות היקף מהפקדה %',
    areFeesIncludingVAT: 'האם העמלות כוללות מע״מ',
    agentNumber: 'מספר סוכן',
    payeeFeesStartDate: 'החל מתאריך לעמלות נפרעים',
    payeeFeesValidityDate: 'תאריך תוקף לעמלות נפרעים',
    isPayeeFeesVatIncluded: 'האם העמלות כוללות מע״מ?',
    volumeFeesStartDate: 'החל מתאריך לעמלות היקף',
    volumeFeesValidityDate: 'תאריך תוקף לעמלות היקף',
    isVolumeFeesVatIncluded: 'האם העמלות כוללות מע״מ?',
    comments: 'הערות',
  },
  side: {
    tabs: 'מידע נוסף',
    comments: 'הערות',
    histories: 'היסטוריה',
    actions: 'פעולות',
  },
};
